import React, { useContext, useState } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { TrainingProps } from 'types/TrainingProps';
import SimpleInput from 'components/SimpleInput';
import { generateUid } from 'utils/functions';
import EditorQuill from 'components/EditorQuill';
import TitleForm from 'components/TitleForm';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { addTraining, editTraining } from './reqs';
import { canSave } from './functions';
import { saveOrderReq } from 'pages/ScreensTrainings/reqs';

const intialDataForm: TrainingProps = {
	id: generateUid(),
	title: '',
	date: '',
	description: '',
	urlVideo: '',
	position: 0,
	content: {
		title: '',
		description: '',
		urlPdf: ''
	}
};

interface FormTrainingProps {
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	trainingToEdit: TrainingProps | null;
	trainings: TrainingProps[];
	setTrainings: React.Dispatch<React.SetStateAction<TrainingProps[]>>;
	resetFunction: () => void;
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FormTraining({
	isOpenForm,
	setIsOpenForm,
	trainingToEdit,
	resetFunction,
	setTrainings,
	setIsLoad,
	trainings
}: FormTrainingProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = useState(
		trainingToEdit
			? trainingToEdit
			: {
					...intialDataForm,
					position: trainings[trainings.length - 1]?.position + 1 || 1
				}
	);

	async function saveTraining() {
		const dataFormOK = canSave(dataForm, handleNotify);

		if (!dataFormOK) {
			return;
		}

		setIsOpenLoad(true);

		if (trainingToEdit === null) {
			setMessage('Adicionando blog...');
			await addTraining(
				dataForm,
				setTrainings,
				setIsLoad,
				trainings,
				handleNotify
			);
		} else {
			setMessage('Editando blog...');
			await saveOrderReq(trainings, handleNotify, false);
			await editTraining(
				dataForm,
				trainingToEdit,
				setTrainings,
				setIsLoad,
				trainings,
				handleNotify
			);
		}

		setIsOpenLoad(false);
		resetFunction();
	}

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetFunction();
			}}
			title={trainingToEdit ? 'Editar treinamento' : 'Adicionar treinamento'}
			buttonClose={false}
		>
			<S.container>
				<S.box>
					<S.forms>
						<TitleForm title="Dados principais">
							<S.gapDiv>
								<S.twoInputsRow>
									<SimpleInput
										label="Título"
										initialValue={dataForm.title}
										getValue={(value: string) => {
											setDataForm((obj) => ({ ...obj, title: value }));
										}}
									/>

									<SimpleInput
										paddingInLineEnd
										label="Data de criação"
										typeInput="date"
										initialValue={dataForm.date}
										getValue={(value: string) => {
											setDataForm((obj) => ({
												...obj,
												date: value
											}));
										}}
									/>
								</S.twoInputsRow>

								<EditorQuill
									title="Descrição"
									value={dataForm.description}
									onChange={(value: string) => {
										setDataForm((obj) => ({ ...obj, description: value }));
									}}
								/>

								<SimpleInput
									label="URL do vídeo"
									initialValue={dataForm.urlVideo}
									getValue={(value: string) => {
										setDataForm((obj) => ({ ...obj, urlVideo: value }));
									}}
								/>
							</S.gapDiv>
						</TitleForm>

						<TitleForm title="Conteúdo do treinamento">
							<S.gapDiv>
								<S.twoInputsRow>
									<SimpleInput
										label="Título"
										initialValue={dataForm.content.title}
										getValue={(value: string) => {
											setDataForm((obj) => ({
												...obj,
												content: { ...dataForm.content, title: value }
											}));
										}}
									/>

									<SimpleInput
										label="URL do PDF"
										initialValue={dataForm.content.urlPdf}
										getValue={(value: string) => {
											setDataForm((obj) => ({
												...obj,
												content: { ...dataForm.content, urlPdf: value }
											}));
										}}
									/>
								</S.twoInputsRow>

								<EditorQuill
									title="Conteúdo"
									value={dataForm.content.description}
									onChange={(value: string) => {
										setDataForm((obj) => ({
											...obj,
											...dataForm,
											content: { ...dataForm.content, description: value }
										}));
									}}
								/>
							</S.gapDiv>
						</TitleForm>
					</S.forms>
				</S.box>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetFunction();
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={async () => {
							await saveTraining();
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
